import e from "@dialpad/dialtone-tokens/layered/themes/tokens-rhubarb-colors.css?inline";
//#region themes/rhubarb.js
var t = {
	brand: {
		css: e,
		name: "rhubarb"
	},
	material: { name: "sandstone" }
};
//#endregion
export { t as default };
